export const isSystemOwner = (user) =>
  Boolean(
    user &&
      (user.profile === "super" ||
        user.super === true ||
        user.super === 1 ||
        String(user.super) === "1")
  );

export const isCompanyAdmin = (user) =>
  Boolean(
    user &&
      (user.profile === "admin" ||
        user.profile === "super" ||
        user.super === true ||
        user.super === 1 ||
        String(user.super) === "1")
  );

export const isSupervisor = (user) => user?.profile === "supervisor";

export const canSeeTeamTickets = (user) =>
  isCompanyAdmin(user) || isSupervisor(user);

export const normalizeCanRole = (profile) => {
  if (profile === "super") return "admin";
  return profile;
};

export const profileI18nKey = (profile) => {
  if (profile === "admin" || profile === "super") return "users.profiles.admin";
  if (profile === "supervisor") return "users.profiles.supervisor";
  return "users.profiles.user";
};
